var map = {
  "./CA/es.json": [
    "45862",
    [
      2267
    ]
  ],
  "./CA/en.json": [
    "1357",
    [
      4574
    ]
  ],
  "./CA/fr.json": [
    "49086",
    [
      7123
    ]
  ],
  "./US/ar.json": [
    "31749",
    [
      9910
    ]
  ],
  "./US/de.json": [
    "50657",
    [
      5194
    ]
  ],
  "./US/fr.json": [
    "7382",
    [
      3083
    ]
  ],
  "./US/en.json": [
    "31157",
    [
      3366
    ]
  ],
  "./US/tr.json": [
    "12472",
    [
      8561
    ]
  ],
  "./CA/ar.json": [
    "38381",
    [
      2734
    ]
  ],
  "./CA/tr.json": [
    "22688",
    [
      2025
    ]
  ],
  "./CA/nl.json": [
    "3504",
    [
      9417
    ]
  ],
  "./US/nl.json": [
    "14056",
    [
      7969
    ]
  ],
  "./CA/de.json": [
    "76233",
    [
      2914
    ]
  ],
  "./US/es.json": [
    "446",
    [
      1043
    ]
  ],
  "./CA/it.json": [
    "88327",
    [
      1212
    ]
  ],
  "./US/it.json": [
    "71887",
    [
      9796
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 940;
module.exports = __rspack_async_context;
